/**
 * 資格のクエリキー
 */
export const certificationsKeys = {
  all: ["educationsAndQualifications", "certifications"] as const,
  list: (params?: unknown) =>
    [...certificationsKeys.all, "list", params] as const,
} as const;
